export enum CustomFieldType {
  Number = 1,
  Text,
  Dropdown,
  Switch,
  CheckOptions,
  Checkbox,
  DynamicDropdown,
}
